import { gql } from "@apollo/client";

export const MERGE_INVOICE_UPLOAD_DOCUMENTS = gql`
  mutation mergeInvoiceUploadDocuments($input: MergeUploadDocumentsInput!) {
    documentHandler {
      mergeInvoiceUploadDocuments(input: $input) {
        success
        id
      }
    }
  }
`;
